import Nd1SiteNav from "./Nd1SiteNav";

/**
 * ND1 hiring workspace shell — same top nav as the rest of the site.
 */
export default function Nd1RecruitmentShell({ children }) {
  return (
    <div className="nd1-root nd1-root--hiring nd1-hiring-app jw-recruitment-page">
      <Nd1SiteNav />
      {children}
    </div>
  );
}
